import React from 'react';
import ReactDOM from 'react-dom/client';
import RodnoyRaionPage from './components/User/RodnoyRaionPage/RodnoyRaionPage';
import { initTelegramWebApp } from './services/telegramWebApp';
initTelegramWebApp();
ReactDOM.createRoot(document.getElementById('root')).render(<RodnoyRaionPage/>);
